import clsx from 'clsx'
import React from 'react'
import Translator from '../../common/translate/Translator'

type NormalButtonParams = {
  onClick: (params?: any) => void
  disabled?: boolean
  text: string
  className?: string
}

function NormalButton(props: NormalButtonParams) {
  return (
    <a
      href='#'
      onClick={props.onClick}
      //disabled={userState.data?.lastInvitationStatus != null}
      className={clsx('btn btn-primary', props.className, {
        disabled: props.disabled ?? false,
      })}
    >
      <span className='indicator-label'>
        <Translator name={props.text} />
      </span>
    </a>
  )
}

export default NormalButton
